/** Long enough for the Save spinner to register rather than flash. */
export const MINIMUM_SAVE_SPINNER_MS = 500;

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
